import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobService } from '../../services/job/job.service';

interface JobLog {
  id: number;
  when: string;          // formatted by the API the way twin-ci did
  user: string;
  action: string;
  slug: string;
  text: string | null;   // plain logs
  data: { key: string, value: string }[] | null;   // "array" logs, unpacked by the API
}

// Log History for one job (moved from twin-ci Administrator::logs; mockup inspection-logs).
// Administrators only: the API answers 403 to everyone else.
@Component({
  selector: 'app-inspection-logs',
  templateUrl: './inspection-logs.component.html',
  styleUrls: ['./inspection-logs.component.scss']
})
export class InspectionLogsComponent implements OnInit {
  page_title = 'Inspection Logs';
  jobId: string;
  logs: JobLog[] = [];
  loading = true;
  // Set when loading fails: the API reason (the app's error interceptor passes on only the
  // message text, e.g. the administrators-only answer), or a generic one.
  errorMessage = '';
  // Array logs whose data is shown (twin-ci's "Show Data" / "Hide Data").
  open: { [id: number]: boolean } = {};

  constructor(private route: ActivatedRoute, private jobService: JobService) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.jobId = params.jobId;
      this.load();
    });
  }

  load() {
    this.loading = true;
    this.errorMessage = '';
    this.open = {};
    this.jobService.getLogs(this.jobId).subscribe(
      data => {
        this.logs = (data && data.logs) || [];
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.logs = [];
        this.errorMessage = typeof error === 'string' && error ? error : 'The log history could not be loaded.';
      }
    );
  }

  toggle(log: JobLog) {
    this.open[log.id] = !this.open[log.id];
  }
}
